/* src/app/attachment-list/attachment-list.component.scss */
.attachment-container .attachment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.attachment-container .attachment-header .attachment-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.attachment-container .attachment-header .attachment-info .title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.attachment-container .attachment-header .attachment-info .meta {
  font-size: 13px;
  color: #666;
}
.attachment-container .attachment-header .attachment-info .limit-text {
  font-size: 13px;
  color: #777;
}
.attachment-container .attachment-header .choose-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: solid 1px #2e93a1;
  border-radius: 4px;
  background: transparent;
  color: #2e93a1;
  font-size: 12px;
  cursor: pointer;
}
.attachment-container .attachment-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.attachment-container .attachment-list .file-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 180px;
  max-width: 260px;
  padding: 8px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fafafa;
}
.attachment-container .attachment-list .file-chip .file-icon {
  flex-shrink: 0;
  font-size: 18px;
}
.attachment-container .attachment-list .file-chip .file-details {
  flex: 1;
  min-width: 0;
}
.attachment-container .attachment-list .file-chip .file-details .file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 500;
  color: #333;
}
.attachment-container .attachment-list .file-chip .file-details .file-size {
  margin-top: 2px;
  font-size: 11px;
  color: #969696;
}
.attachment-container .attachment-list .file-chip .remove-btn {
  flex-shrink: 0;
  border: none;
  background: transparent;
  font-size: 18px;
  line-height: 1;
  color: #969696;
  cursor: pointer;
}
.attachment-container .attachment-list .file-chip .remove-btn:hover {
  color: #d9534f;
}
/*# sourceMappingURL=attachment-list.component-QAQXXZHL.css.map */
